import { Handle, Position, type NodeProps } from '@xyflow/react';

import { useTranslation } from 'src/core/common/hooks/useTranslation';

import { useRegisterNodeHeight } from '../../hooks/useRegisterNodeHeight';

export type LabelNodeData = {
  nodeType: 'labelNode';
};

const handleStyle = {
  background: 'transparent',
  border: 'none',
  width: 0,
  height: 0,
};

export const LabelNode = ({ id }: NodeProps) => {
  const { t } = useTranslation('global');
  const nodeReference = useRegisterNodeHeight<HTMLDivElement>(id);

  return (
    <div ref={nodeReference} className="flex h-[88px] items-center">
      <div className="rounded bg-background-primary-default px-8 py-4 text-content-primary title-m">
        {t('approvalWorkflows.labelNode.whenARequestIsMade')}
      </div>
      <Handle
        style={handleStyle}
        type="source"
        id="rightHandle"
        position={Position.Right}
      />
      <Handle
        style={handleStyle}
        type="source"
        id="bottomHandle"
        position={Position.Bottom}
      />
    </div>
  );
};
